import { render, staticRenderFns } from "./ViewCircleArticle.vue?vue&type=template&id=60878140"
import script from "./ViewCircleArticle.vue?vue&type=script&lang=js"
export * from "./ViewCircleArticle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports